import { Button, Card, Col, Flex, Typography } from 'antd'
import Title from 'antd/es/skeleton/Title'
import React from 'react'
import Failed from "../images/failed.gif"
import { useNavigate, useSearchParams } from 'react-router-dom'
const PaymentFailedScreen = () => {
    const navigate = useNavigate();
    const {Title} = Typography;
    const searchQuery = useSearchParams()[0];
    const referenceid = searchQuery.get("reference");

  return (
    <Flex justify='center' style={{height: "100vh"}}>
    <Col md={10}>
        <Card style={{textAlign: "center"}} title={"⚠️ Payment Unsuccessful ⚠️"} actions={[<Button onClick={e => navigate('/Dashboard')} type='primary'>Go Back to Dashboard</Button>]}>
        
        <Title level={5}>
            Oops! It looks like your payment didn’t go through. Your Lincfolio subscription hasn’t been activated yet
        </Title>
        <img src={Failed}/>
        <Title level={5}>
            Your Payment reference Id: {referenceid}
        </Title>

        <Title level={5}>
            Please check your payment details and try again. If you continue to experience issues, our support team is here to help!
        </Title>

        <Title level={5}>
        Thank you for choosing Lincfolio — we’re excited to support your trading journey!
        </Title>
        </Card>
    </Col>
</Flex>
  )
}

export default PaymentFailedScreen